<ng-container *ishProductContextAccess="let product = product">
  <div class="row" data-testing-id="wishlist-product">
    <div class="col-3 col-md-2 list-item">
      <ish-product-image imageType="S" [link]="true" />
    </div>
    <div class="col-9 col-md-10 list-item column-price">
      <div class="row">
        <div class="col-md-7 text-left">
          <div class="pli-description">
            <ish-product-name />
            <ish-product-id />
            <ish-product-variation-display />
            <ish-product-bundle-display />
            <div class="d-none d-sm-block">
              <span class="col-form-label">{{ 'wishlist.table.added_on' | translate }}</span>
              {{ wishlistItemData()?.creationDate | ishDate : 'shortDate' }}
            </div>
            @if (!readOnly()) {
            <div class="mb-2">
              <button
                type="button"
                class="btn-tool btn-link"
                [title]="'wishlist.table.options.move_to_another_wishlist' | translate"
                (click)="moveDialog.show()"
                data-testing-id="move-wishlist"
              >
                <fa-icon [icon]="['fas', 'arrows-alt']" />
              </button>
              <button
                type="button"
                class="btn-tool btn-link"
                [title]="'wishlist.table.options.remove' | translate"
                (click)="removeProductFromWishlist(wishlistItemData().sku)"
                data-testing-id="delete-wishlist"
              >
                <fa-icon [icon]="['fas', 'trash-alt']" />
              </button>
            </div>
            }
          </div>
        </div>

        <div class="col-12 col-md-5 product-list-actions-container">
          <ish-product-price />
          @if (product.available) {
          <p>
            {{ 'wishlist.table.in_stock' | translate }}
          </p>
          } @else {
          <p>{{ 'wishlist.table.not_accessible' | translate }}</p>
          } @if (product.available) {
          <div class="row product-quantity">
            <div class="col-6 offset-md-6 col-lg-5 offset-lg-0">
              <ish-product-quantity />
            </div>
            <div class="col-12 col-lg-7 addtocart-container">
              <ish-product-add-to-basket />
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <ish-select-wishlist-modal
    #moveDialog
    addMoveProduct="move"
    (submitEmitter)="moveItemToOtherWishlist(wishlistItemData().sku, $event)"
  />
</ng-container>
